import { Regulation } from "./regulation";
import getOr from "lodash/fp/getOr";
import find from "lodash/find";

const arrowDown = require("../assets/images/arrow-down.svg");

export class Ntm {
  constructor(code, name, desc, regulations, sectionName, index) {
    this.code = code;
    this.name = name;
    this.desc = desc;
    this.regulations = regulations;
    this.sectionName = sectionName;
    this.index = index;
  }

  genHtml() {
    let items = "";
    this.regulations.forEach(item => {
      items += item.genHtml();
    });
    const desc = this.desc ? `<div class="desc">${this.desc}</div>` : "";
    return `
      <div class="item">
        <div class="head d-flex collapsed" data-toggle="collapse" data-target="#${this.sectionName}-${this.index}" aria-expanded="false" aria-controls="${this.sectionName}-${this.index}" >
          <div class="title mr-auto">${this.name}</div>
          <div class="num">${this.regulations.length}</div>
          <div class="arrow">
            <img src="${arrowDown}" alt="arrow down" />
          </div>
        </div>
        <div class="collapse data" id="${this.sectionName}-${this.index}">
          ${desc}
          ${items}
        </div>
      </div>
    `;
  }

  static fromApiObject(input, ntmReferences, regulationReference, sectionName, index) {
    if (typeof (input) === "object" && input !== null) {
      const code = getOr("", "ntmCode")(input);
      const regulations = Regulation.fromApiArray(getOr([], "regulations")(input), regulationReference, sectionName, index);
      const obj = ntmReferences ? find(ntmReferences, { code: code }) : input;
      const name = getOr("", "name")(obj);
      const desc = getOr("", "desc")(obj);
      return new Ntm(code, name, desc, regulations, sectionName, index);
    }
    return new Ntm();
  }
  static fromApiArray(input, ntmReferences, regulationReference, sectionName) {
    if (Array.isArray(input)) {
      return input.map((item, index) => Ntm.fromApiObject(item, ntmReferences, regulationReference, sectionName, index));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Ntm.fromApiObject(input, ntmReferences, regulationReference, sectionName, 0)];
    }
    return [];
  }
}